<template>
  <div id="workPlanQuery">
    <v-header title="工作计划查询"></v-header>
    <div v-cloak class="searchList">
      <el-collapse v-model="activeNames">
        <el-collapse-item title="查询条件" name="1">
          <el-form :inline="true" :label-position="labelPosition" label-width="140px" :model="formObj" class="demo-form-inline">
            <el-form-item label="机构" style="width:25%">
              <el-cascader
                v-model="formObj.org"
                :options="org_options"
                :props="props"
                change-on-select
                clearable
                ref="orgCascader"
                @change="handleOrgChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="计划创建日期" style="width:36%">
              <el-date-picker
                v-model="formObj.createDateRange"
                type="daterange"
                :clearable="true"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                unlink-panels>
              </el-date-picker>
            </el-form-item>
            <el-form-item label="计划执行日期" style="width:36%">
              <el-date-picker
                v-model="formObj.executeDateRange"
                type="daterange"
                :clearable="true"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                unlink-panels>
              </el-date-picker>
            </el-form-item>
            <el-form-item label="客户姓名" style="width:25%">
              <el-input v-model="formObj.customerName" clearable placeholder="请输入客户姓名"></el-input>
            </el-form-item>
            <el-form-item label="业务员编码" style="width:25%">
              <el-input v-model="formObj.agentId" clearable placeholder="请输入业务员编码"></el-input>
            </el-form-item>
            <el-form-item label="业务员姓名" style="width:25%">
              <el-input v-model="formObj.agentName" clearable placeholder="请输入业务员姓名"></el-input>
            </el-form-item>
            <el-form-item label="工作计划类型" style="width:25%">
              <el-cascader
                ref="planTypeCascader"
                v-model="selectedPlanValue"
                :options="planType_options"
                :props="planTypeProps"
                clearable
                @change="handlePlanTypeChange"
              />
            </el-form-item>
            <el-form-item label="工作计划状态" style="width:25%">
              <el-select v-model="formObj.planStatus" clearable placeholder="请选择">
                <el-option
                  v-for="item in planStatus_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否有辅助资料" style="width:25%">
              <el-select v-model="formObj.isAuxiliaryInformation" clearable placeholder="请选择">
                <el-option label="是" value="Y"></el-option>
                <el-option label="否" value="N"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="width: 100%; display: flex; justify-content: flex-end;">
              <el-button type="primary" @click="exportData">导出</el-button>
              <el-button type="primary" @click="searchData">查询</el-button>
              <el-button type="primary" @click="resetData">重置</el-button>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      
      <div class="result">查询结果</div>
      <el-table
        :data="tableData"
        border
        style="width: 100%;fontSize:12px;"
        v-loading="loading">
        <el-table-column
          type="index"
          fixed
          align="center"
          label="序号"
          width="50">
        </el-table-column>
        <el-table-column
          prop="secondaryOrgName"
          label="二级机构"
          align="center"
          width="80">
        </el-table-column>
        <el-table-column
          prop="tertiaryOrgName"
          label="三级机构"
          align="center"
          width="80">
        </el-table-column>
        <el-table-column
          prop="quaternaryOrgName"
          label="四级机构"
          align="center"
          width="120">
        </el-table-column>
        <el-table-column
          prop="agentId"
          label="业务员编码"
          align="center"
          width="120">
        </el-table-column>
        <el-table-column
          prop="agentName"
          label="业务员姓名"
          align="center"
          width="110">
        </el-table-column>
        <el-table-column
          prop="planType"
          label="工作计划类型"
          align="center"
          width="120"
          :formatter="formatPlanType">
        </el-table-column>
        <el-table-column
          prop="completionStatus"
          label="工作计划状态"
          align="center"
          width="120">
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户姓名"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          prop="idType"
          label="证件类型"
          align="center"
          width="120">
        </el-table-column>
        <el-table-column
          prop="idNo"
          label="证件号"
          align="center"
          width="180">
        </el-table-column>
        <el-table-column
          prop="customerLaNum"
          label="客户号"
          align="center"
          width="120">
        </el-table-column>
        <el-table-column
          prop="crtDate"
          label="计划创建时间"
          align="center"
          width="180">
        </el-table-column>
        <el-table-column
          prop="visitEndTime"
          label="计划执行时间"
          align="center"
          width="180">
        </el-table-column>
        <el-table-column
          prop="isAuxiliaryInformation"
          label="是否有辅助资料"
          align="center"
          width="120">
        </el-table-column>
        <el-table-column
          prop="operation"
          label="操作"
          fixed="right"
          align="center"
          width="100">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="viewDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="contentFooter">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :current-page="currentPage"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
      <!-- 详情弹窗 -->
      <el-dialog
        title="工作计划详情"
        :visible.sync="detailDialogVisible"
        width="70%"
        :append-to-body="true"
        center
        @close="handleDialogClose">
        <div class="detail-container">
          <!-- 客户信息模块 -->
          <div class="info-section" v-if="hasCustomerInfo">
            <div class="section-title">客户信息</div>
            <el-descriptions :column="2" border>
              <el-descriptions-item label="客户姓名" v-if="detailData.customerName">
                {{ detailData.customerName }}
              </el-descriptions-item>
              <el-descriptions-item label="证件信息" v-if="detailData.idNo && detailData.idType">
                {{ getIdTypeText(detailData.idType) }} {{ desensitizeIdNumber(detailData.idNo) }}
              </el-descriptions-item>
              <el-descriptions-item label="客户号（LA）" v-if="detailData.customerLaNum">
                {{ detailData.customerLaNum }}
              </el-descriptions-item>
              <el-descriptions-item label="手机号" v-if="detailData.mobile">
                {{ desensitizeMobile(detailData.mobile) }}
                <span v-if="customerBindInfo" class="bind-status" :style="{color: customerBindInfo.color}">
                  {{ customerBindInfo.text }}
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="绑定微信账号" v-if="detailData.custAvatar && detailData.custNickname">
                <div class="wechat-info">
                  <img v-if="detailData.custAvatar" :src="detailData.custAvatar" class="avatar" />
                  <span v-if="detailData.custNickname">{{ detailData.custNickname }}</span>
                </div>
              </el-descriptions-item>
              
            </el-descriptions>
          </div>
          
          <!-- 计划名称 -->
          <div class="info-section" v-if="detailData.planName">
            <el-descriptions :column="2" border>
              <el-descriptions-item label="计划名称" :span="2">
                {{ detailData.planName }}
              </el-descriptions-item>
            </el-descriptions>
          </div>

          <!-- 计划类型模块 -->
          <div class="info-section" v-if="detailData.planTypeName || detailData.planType">
            <div class="section-title">计划类型</div>
            <el-descriptions :column="1" border>
              <el-descriptions-item label="计划类型">
                {{ detailData.planTypeName || formatPlanTypeValue(detailData.planType) }}
              </el-descriptions-item>
            </el-descriptions>
          </div>

          <!-- 时间信息模块 -->
          <div class="info-section" v-if="hasTimeInfo">
            <div class="section-title">时间信息</div>
            <el-descriptions :column="2" border>
              <el-descriptions-item label="计划开始时间">
                {{ detailData.startTime || '--' }}
              </el-descriptions-item>
              <el-descriptions-item label="计划结束时间">
                {{ detailData.endTime || '--' }}
              </el-descriptions-item>
              <el-descriptions-item label="提醒方式" v-if="remindType">
                {{ remindType }}
              </el-descriptions-item>
              <el-descriptions-item label="实际开始时间">
                {{ detailData.visitStartTime || '--' }}
              </el-descriptions-item>
              <el-descriptions-item label="实际结束时间">
                {{ detailData.visitEndTime || '--' }}
              </el-descriptions-item>
            </el-descriptions>
          </div>

          <!-- 面访结果模块 -->
          <div class="info-section" v-if="interviewResult">
            <div class="section-title">面访结果</div>
            <el-descriptions :column="2" border>
              <el-descriptions-item label="面访结果" :span="2">
                <span class="result-success">{{ interviewResult }}</span>
              </el-descriptions-item>
              <el-descriptions-item label="计划面访地址" v-if="detailData.faceAddress" :span="2">
                {{ detailData.faceAddress }}
              </el-descriptions-item>
              <el-descriptions-item label="面访验证客户微信" v-if="detailData.custNickname" :span="2">
                <div class="wechat-info">
                  <img v-if="detailData.custAvatar" :src="detailData.custAvatar" class="avatar" />
                  <span v-if="detailData.custNickname">{{ detailData.custNickname }}</span>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="辅助资料" v-if="detailData.auxiliaryInformation" :span="2">
                <img :src="detailData.auxiliaryInformation" class="auxiliary-img" @click="previewAuxiliaryImage"/>
              </el-descriptions-item>
            </el-descriptions>
          </div>

          <!-- 工作总结模块 -->
          <div class="info-section" v-if="detailData.workSummaries">
            <div class="section-title">工作计划总结</div>
            <el-descriptions :column="1" border>
              <el-descriptions-item label="工作总结">
                {{ detailData.workSummaries }}
              </el-descriptions-item>
              <el-descriptions-item label="总结完成时间">
                {{ detailData.workSummariesTime || '--' }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="detailDialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 图片预览弹窗 -->
      <el-dialog
        title="辅助资料预览"
        :visible.sync="imagePreviewVisible"
        width="60%"
        :append-to-body="true"
        center
        @close="handleImagePreviewClose">
        <div class="image-preview-container">
          <img :src="previewImageUrl" class="preview-image" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="downloadAuxiliaryImage">
            <i class="el-icon-download"></i> 下载图片
          </el-button>
          <el-button type="primary" @click="imagePreviewVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import url from '@/modules/url'
  import api from '@/modules/api'
  import vHeader from '@/layout/Header1.vue'
  import { Options } from "@/components/utils/fixOptions";
  
  export default {
    components: { vHeader },
    name: 'customerPlanQuery',
    data() {
      return {
        labelPosition: 'right',
        activeNames: '1',
        loading: false,
        formObj: {
          org: [],
          createDateRange: this.getDefaultDateRange(), // 设置默认日期范围
          executeDateRange: [],
          customerName: '',
          agentId: '',
          agentName: '',
          planCategory: '', // 计划大类
          planType: '', // 计划小类
          planStatus: '',
          isAuxiliaryInformation: ''  // 是否有辅助资料Y/N
        },
        org_options: [],
        props:{
          value: 'orgCode',
          label:'orgName',
          children: 'affiliates',
          checkStrictly: true,
          emitPath: true
        },
        planType_options: [],
        // 字段映射配置
        planTypeProps: {
          value: 'code',    // 选项的实际值字段
          label: 'name',    // 选项显示文本字段
          children: 'children', // 子选项字段
          disabled: function(node) {
            // 判断是否为第一级（level 从 0 开始）
            return node.level === 0;
          },
        },
        selectedPlanValue: [],
        planStatus_options: [
          { label: '未完成', value: '0' },
          { label: '已完成', value: '1' }
        ],
        tableData: [],
        pageSize: 10,
        currentPage: 1,
        totalCount: 0,
        detailDialogVisible: false,
        bindStatus: {
          '1': { text: '未注册未绑定', color: '#ff9800' },
          '2': { text: '已注册未绑定', color: '#ff9800' },
          '3': { text: '已注册已绑定', color: '#52c41a' }
        },
        detailData: {},
        imagePreviewVisible: false,
        previewImageUrl: ''
      }
    },
    computed: {
      // 判断各个模块是否有数据
      hasCustomerInfo() {
        const d = this.detailData;
        return d && (d.customerName || d.customerLaNum || d.mobile || d.unionId || d.planName || d.idNo);
      },
      hasTimeInfo() {
        const d = this.detailData;
        return d && (d.startTime || d.endTime);
      },
      // 提醒方式文本
      remindType() {
       // 获取提醒分钟数组
        const remindMinutes = this.detailData && this.detailData.remindMinutes ? this.detailData.remindMinutes : [];
        
        // 空值或空数组判断
        if (!remindMinutes || !Array.isArray(remindMinutes) || remindMinutes.length === 0) {
          return '无提醒';
        }
        
        // 过滤空字符串和无效值
        const validMinutes = remindMinutes.filter(m => m !== '' && m !== null && m !== undefined);
        
        if (validMinutes.length === 0) {
          return '无提醒';
        }
        
        // 映射为显示文本
        const typeTexts = validMinutes.map(minute => {
          const minuteStr = String(minute);
          const option = Options.reminderOptions.find(opt => opt.value === minuteStr);
          return option ? option.label : `${minuteStr}分钟前`;
        });
        
        return typeTexts.join('、');
      },
      // 面访结果文本
      interviewResult() {
        if (this.detailData.visitResult === '2') {
          return '面访成功';
        } else if (this.detailData.visitResult === '1') {
          return '面访失败';
        }
        return '';
      },
      // 客户绑定状态信息
      customerBindInfo() {
        return this.detailData.bindStatus && this.bindStatus[this.detailData.bindStatus] 
          ? this.bindStatus[this.detailData.bindStatus] 
          : null;
      }
    },
    mounted() {
      this.getOrgList()
      this.getEnum()

      // 初始化时如果创建日期范围为空，则设置默认值
      if (!this.formObj.createDateRange || this.formObj.createDateRange.length === 0) {
        this.formObj.createDateRange = this.getDefaultDateRange()
      }
    },
    methods: {
      // 获取工作计划类型：计划大类、小类
      getEnum() {
        api.post(url.getEnum, { enumNo: 'work_plan' }, (res) => {
          if (res.result.isSuccess) {
            this.planType_options = res.data;
          }
        }, (err) => {
          console.log(err, '=====获取工作计划类型异常')
        })
      },
      // 格式化工作计划类型显示
      formatPlanType(row, column, cellValue) {
        if (!cellValue) return '-'
        // 递归查找节点名称
        const findNodeName = (nodes, code) => {
          for (const node of nodes) {
            if (node.code === code) {
              return node.name
            }
            if (node.children && node.children.length) {
              const result = findNodeName(node.children, code)
              if (result) return result
            }
          }
          return null
        }
        const name = findNodeName(this.planType_options, cellValue)
        return name || cellValue // 找不到则显示原code
      },
      // 获取默认日期范围（近一个月）
      getDefaultDateRange() {
        const endDate = new Date()
        const startDate = new Date()
        startDate.setMonth(startDate.getMonth() - 1)
        
        // 格式化为 yyyy-MM-dd
        const formatDate = (date) => {
          const year = date.getFullYear()
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const day = String(date.getDate()).padStart(2, '0')
          return `${year}-${month}-${day}`
        }
        
        return [formatDate(startDate), formatDate(endDate)]
      },

      // 处理机构选择变化，选择后关闭下拉框
      handleOrgChange() {
        // 延迟关闭，确保值已经更新
        this.$nextTick(() => {
          if (this.$refs.orgCascader) {
            this.$refs.orgCascader.toggleDropDownVisible(false)
          }
          console.log(this.formObj.org, '======机构')
        })
      },
      // 选择工作计划类型
      handlePlanTypeChange() {
        console.log(this.selectedPlanValue, '=========selectedPlanValue')
        if (Array.isArray(this.selectedPlanValue) && this.selectedPlanValue.length) {
          this.formObj.planCategory = this.selectedPlanValue[0]
          this.formObj.planType = this.selectedPlanValue[1]
        }
        // 延迟关闭，确保值已经更新
        this.$nextTick(() => {
          if (this.$refs.planTypeCascader) {
            this.$refs.planTypeCascader.toggleDropDownVisible(false)
          }
        })
      },
      // 获取机构列表
      getOrgList() {
        api.post(url.orgQueryOfPolicyList, {"org_province":"HO"}, (res) => {
          if(res.result.isSuccess) {
            // 只保留前两级机构数据
            this.org_options = this.filterOrgLevels(res.data.result, 2)
            console.log(this.org_options, '===只保留前两级机构数据')
          }
        })
      },
      
      // 过滤机构层级，只保留指定层级的数据
      filterOrgLevels(orgList, maxLevel, currentLevel = 1) {
        if (!orgList || !Array.isArray(orgList)) return []
        
        return orgList.map(org => {
          const newOrg = { ...org }
          
          // 如果当前层级已达到最大层级，移除子节点
          if (currentLevel >= maxLevel) {
            delete newOrg.affiliates
          } else if (newOrg.affiliates && newOrg.affiliates.length > 0) {
            // 递归处理子节点
            newOrg.affiliates = this.filterOrgLevels(newOrg.affiliates, maxLevel, currentLevel + 1)
          }
          
          return newOrg
        })
      },
      
      
      // 查询按钮
      searchData() {
        this.currentPage = 1
        this.searchList()
      },
      
      // 查询列表
      searchList() {
        this.loading = true
        const params = this.buildSearchParams('query')
        api.post(url.queryCustomerPlansByPc, params, (res) => { 
          if (res.result.isSuccess) {
            this.tableData = res.data.list || []
            this.totalCount = res.data.totalCount || 0
          } else {
            this.tableData = []
            this.totalCount = 0
            this.currentPage = 1
            this.$message(res.result.error);
          }
          this.loading = false
        }, (err) => {
          this.loading = false
          console.log(err, '=====查询列表异常')
        })
      },

      // 构建搜索参数，处理机构参数
      buildSearchParams(operateType='query', isPage=true) {
        let provinceCode = ''
        let cityCode = ''
        if (Array.isArray(this.formObj.org) && this.formObj.org.length) {
          provinceCode = this.formObj.org[0]
          cityCode = this.formObj.org[1] ? this.formObj.org[1].slice(1) : ''
        }
        let params = {
          provinceCode: provinceCode,
          cityCode: cityCode,
          createTimeStart: this.formObj.createDateRange && this.formObj.createDateRange[0] ? this.formObj.createDateRange[0] + ' 00:00:00' : '',
          createTimeEnd: this.formObj.createDateRange && this.formObj.createDateRange[1] ? this.formObj.createDateRange[1] + ' 23:59:59' : '',
          visitTimeStart:  this.formObj.executeDateRange && this.formObj.executeDateRange[0] ? this.formObj.executeDateRange[0] + ' 00:00:00' : '',
          visitTimeEnd: this.formObj.executeDateRange && this.formObj.executeDateRange[1] ? this.formObj.executeDateRange[1] + ' 23:59:59' : '',
          customerName: this.formObj.customerName,
          agentId: this.formObj.agentId,
          agentName: this.formObj.agentName,
          planCategory: this.formObj.planCategory,
          planType: this.formObj.planType,
          planState: this.formObj.planStatus,
          isAuxiliaryInformation: this.formObj.isAuxiliaryInformation,
          operateType: operateType // query查询，export导出
        }
        if (isPage) {
          params.nowPage = this.currentPage
          params.rows4Page = this.pageSize
        }

        return params;
      },
      
      // 导出按钮
      exportData() {
        const params = this.buildSearchParams('export', false)
        api.post(url.exportCustomerPlansByPc, params, (res) => { 
          if (res.result.isSuccess) {
            if (res.data.downLoadUrl) window.location.href = res.data.downLoadUrl
          } else {
            this.$message(res.result.error);
          }
        }, (err) => {
          console.log(err, '=====导出列表异常')
        })
      },
      
      // 重置按钮 - 添加重置时恢复默认日期
      resetData() {
        this.formObj = {
          org: [],
          createDateRange: this.getDefaultDateRange(), // 重置时也恢复默认日期
          executeDateRange: [],
          customerName: '',
          agentCode: '',
          agentName: '',
          planType: '',
          planStatus: '',
          hasSupportMaterial: ''
        }
        this.currentPage = 1
        this.tableData = []
        this.totalCount = 0
        this.selectedPlanValue = []
      },
      
      // 分页切换
      handleCurrentChange(val) {
        this.currentPage = val
        this.searchList()
      },
      
      // 查看详情
      viewDetail(row) {
        if (!row.planId) this.$message('缺少工作计划id')
        const params = {
          planId: row.planId
        }
        api.post(url.queryCustomerPlan, params, (res) => {
          if (res.result.isSuccess) {
            this.detailData = res.data

            // 弹出详情弹窗
            this.detailDialogVisible = true
          } else {
            this.$message(res.result.error)
          }
        },(err) => {
          console.log(err, '===查看详情异常')
        })
      },
      // 获取证件类型文本
      getIdTypeText(type) {
        const item = Options.exingIdTypes.find(item => item.value == type);
        return item ? item.label : '未知';
      },

      // 脱敏手机号
      desensitizeMobile(mobile) {
        if (!mobile) return '';
        if (mobile.length === 11) {
          return mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
        }
        return mobile;
      },

      // 脱敏证件号
      desensitizeIdNumber(idNo) {
        if (!idNo) return '';
        if (idNo.length > 4) {
          return idNo.replace(/^(.{0,}).{4}$/, "$1****");
        }
        return '****';
      },

      // 格式化计划类型显示
      formatPlanTypeValue(code) {
        if (!code) return '-';
        const findNodeName = (nodes, searchCode) => {
          for (const node of nodes) {
            if (node.code === searchCode) {
              return node.name;
            }
            if (node.children && node.children.length) {
              const result = findNodeName(node.children, searchCode);
              if (result) return result;
            }
          }
          return null;
        };
        const name = findNodeName(this.planType_options, code);
        return name || code;
      },

      // 关闭弹窗时的回调
      handleDialogClose() {
        // 重置详情数据
        this.detailData = {};
      },

      // 查看详情
      viewDetail(row) {
        if (!row.planId) {
          this.$message('缺少工作计划id');
          return;
        }
        const params = {
          planId: row.planId
        };
        api.post(url.queryCustomerPlan, params, (res) => {
          if (res.result.isSuccess) {
            const data = res.data;
            // 处理数据格式，适配弹窗展示
            this.detailData = {
              ...this.detailData,
              ...data,
              planId: data.planId || row.planId,
            };
            
            this.detailDialogVisible = true;
          } else {
            this.$message(res.result.error);
          }
        }, (err) => {
          console.log(err, '===查看详情异常');
        });
      },
      // 预览辅助资料图片
      previewAuxiliaryImage() {
        if (this.detailData.auxiliaryInformation) {
          this.previewImageUrl = this.detailData.auxiliaryInformation;
          this.imagePreviewVisible = true;
        } else {
          this.$message.warning('暂无辅助资料图片');
        }
      },
      
      // 下载辅助资料图片
      downloadAuxiliaryImage() {
        const imageUrl = this.detailData.auxiliaryInformation;
        if (!imageUrl) {
          this.$message.warning('暂无辅助资料图片');
          return;
        }
        
        // 方法1：使用 fetch 下载
        fetch(imageUrl)
          .then(response => response.blob())
          .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `辅助资料_${this.detailData.customerName || '图片'}.jpg`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            this.$message.success('下载成功');
          })
          .catch(() => {
            // 方法2：如果 fetch 失败，使用 window.open 方式
            this.downloadImageFallback(imageUrl);
          });
      },
      
      // 备用下载方式
      downloadImageFallback(imageUrl) {
        const link = document.createElement('a');
        link.href = imageUrl;
        link.download = `辅助资料_${this.detailData.customerName || '图片'}.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$message.success('下载成功');
      },
      
      // 关闭图片预览弹窗
      handleImagePreviewClose() {
        this.previewImageUrl = '';
      }
    }
  }
</script>

<style lang="scss" scoped>
#workPlanQuery{
  height:100%;
  box-sizing: border-box;
  background: #fff;
  >>> .el-collapse-item__header {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
}
>>> .el-descriptions-item__cell {
  min-width: 140px !important;
}
.searchList {
  padding: 20px;
  .result {
    margin: 0.2rem 0;
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  
  .contentFooter {
    margin-top: 0.2rem;
    text-align: right;
  }
}

// 详情弹窗样式
.detail-container {
  max-height: 60vh;
  overflow-y: auto;
  padding: 0 10px;
}

.info-section {
  margin-bottom: 20px;
  
  .section-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 12px;
    padding-left: 10px;
    border-left: 4px solid #4A6BBE;
  }
}

.bind-status {
  margin-left: 8px;
  font-size: 12px;
}

.result-success {
  color: #52c41a;
  font-weight: 500;
}

.wechat-info {
  display: flex;
  align-items: center;
  gap: 8px;
  
  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }
}

.auxiliary-img {
  max-width: 200px;
  max-height: 200px;
  cursor: pointer;
}
// 辅助资料样式
.auxiliary-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  
  .auxiliary-img {
    max-width: 300px;
    max-height: 200px;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid #e8e8e8;
    transition: transform 0.3s;
    
    &:hover {
      transform: scale(1.02);
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    }
  }
  
  .auxiliary-actions {
    display: flex;
    gap: 8px;
  }
}

// 图片预览弹窗样式
.image-preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  
  .preview-image {
    max-width: 100%;
    max-height: 70vh;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/workPlanQuery/index.vue